/* eslint-disable*/
import * as ENGLISH from './english.json';
import * as CHINESE from './chinese.json';

const LC = function LC(props) {
  var selectedLanguage = localStorage.getItem('selectedLanguage');
  // console.log('selectedLanguageselectedLanguage')
  // console.log(selectedLanguage)
  // console.log(localStorage.getItem("domainName"))
  // console.log(localStorage.getItem("domainApp"))
  if (
    selectedLanguage === 'null' ||
    selectedLanguage === undefined ||
    selectedLanguage === null ||
    selectedLanguage === ''
  ) {
    // console.log("DONT HAVE ANY LANGUAGE");
    var domainName = localStorage.getItem('domainName');
    var domainApp = localStorage.getItem('domainApp');
    if (domainApp === 'WORLD') {
      //console.log("WORLD WORKING");
      return ENGLISH;
    } else {
      //console.log("CHINA WORKING");
      return CHINESE;
    }
  } else {
    // console.log("HAVE SELECTED LANGUAGE");
    var language_selected = localStorage.getItem('selectedLanguage');
    // console.log(localStorage.getItem("selectedLanguage"));
    switch (language_selected) {
      case 'EN':
        //console.log("ENGLISH WORKING");
        return ENGLISH;
      case 'CH':
        //console.log("CHINESE WORKING");
        return CHINESE;
      default:
        null;
        break;
    }
  }
};

exports.LC = LC;



// WEBPACK FOOTER //
// ./src/assets/languages/language.js